import { useSearchParams } from 'react-router';

import { getPrimaryInboxEntryId } from '@this+that/utils';

import { URL_PARAMS } from '../DataFetch/constants';

/**
 * The entry the user is actually working in. `inboxEntryIds` is an unordered
 * DynamoDB String Set, so the fallback cannot recover "most recently linked" —
 * the route is the only signal that says which DoBox the action belongs to.
 */
export const useActiveInboxEntryId = (
  inboxEntryIds?: string[],
): string | undefined => {
  const [searchParams] = useSearchParams();

  return (
    searchParams.get(URL_PARAMS.DOBOX_ID) ??
    getPrimaryInboxEntryId(inboxEntryIds)
  );
};
